import PropTypes from 'prop-types';
// import { googleApiKey } from '../../../../constants';

const ItineraryMap = ({ sailingItineraryMapImageUrl }) => (
  <>
    {sailingItineraryMapImageUrl && (
      <div>
        {/* <img src="https://maps.googleapis.com/maps/api/staticmap?center=Berkeley,CA&zoom=14&size=400x400&key=AIzaSyBe7lOtnwOHheUk60v2H2fen_WXJp6onYI" /> */}
        {/* <img src="https://maps.googleapis.com/maps/api/staticmap?size=400x400&zoom=3&center=-40.83,54.05&path=color:0xff0000ff|weight:2|-10.833305983642491,64.6875|-55.07836723201513,58.53515625&key=AIzaSyBe7lOtnwOHheUk60v2H2fen_WXJp6onYI" /> */}
        <img
          // src={`${sailingItineraryMapImageUrl}&key=${googleApiKey}`}
          src={sailingItineraryMapImageUrl}
          alt="Sailing map"
          title="Sailing map"
        />
      </div>
    )}
  </>
);

ItineraryMap.propTypes = {
  sailingItineraryMapImageUrl: PropTypes.string,
};

ItineraryMap.defaultProps = {
  sailingItineraryMapImageUrl: undefined,
};

export default ItineraryMap;
